module.exports = __webpack_public_path__ + "assets/img/qq.8968a17d.svg";